import {
  WSActions,
  WSCard,
  WSEmptyState,
  WSList
} from "@wingspanhq/fe-component-library";
import { SetupNewCorrectionProps } from "./index";
import { EditLayout } from "../../../TaxCorrections/components/EditLayout";
import { TaxDocumentsDetailsFAQ } from "../../../TaxDocuments/components/TaxDocumentsDetailsFAQ";
import React from "react";

export const RouteSubmitCorrectionSuccess: React.FC<
  SetupNewCorrectionProps
> = ({ onNext }) => {
  return (
    <EditLayout
      noBack
      title="Start new correction"
      contentRight={<TaxDocumentsDetailsFAQ mb="L" />}
    >
      <WSList gap="2XL">
        <WSCard>
          <WSEmptyState
            type="done"
            orientation="horizontal"
            title="Corrections submitted to the IRS"
            description="We have submitted your correction to the IRS. You can track the acceptance or rejection status of the submission on your tax filing dashboard."
          />
        </WSCard>

        <WSActions
          alignment="fill"
          buttons={[
            {
              label: "Continue",
              onClick: () => {
                onNext?.();
              }
            }
          ]}
        />
      </WSList>
    </EditLayout>
  );
};
